export enum TextAnchor {
  Start = 'start',
  Middle = 'middle',
  End = 'end'
}
